import React from "react";
import FormatListNumberedRtlIcon from '@mui/icons-material/FormatListNumberedRtl';

function Header() {
  return (
    <header>
      <h1><FormatListNumberedRtlIcon/>Keeper</h1>
    </header>
  );
}

export default Header;
